import {
    post,
    downFile,
    postUpload,
    postLong
} from "../utils/request";
let api = {
    // 下载模板
    downloadInsertTemplate: (params) => downFile("/batchOperate/downloadInsertTemplate", params), //下载新增模板
    downloadUpdateTemplate: (params) => downFile("/batchOperate/downloadUpdateTemplate", params), //下载修改模板
    downloadDeleteTemplate: (params) => downFile("/batchOperate/downloadDeleteTemplate", params), //下载删除模板
    downloadUpdateOrCreateTemplate: (params) => downFile("/batchOperate/downloadUpdateOrCreateTemplate", params), //下载新增/修改模板
    downloadErrorMessage: (params) => downFile("/batchOperate/downloadErrorMessage", params), //下载错误信息
    // 上传接口
    uploadInsert: (params) => postUpload("/batchOperate/uploadInsert", params), // 导入新增
    uploadUpdate: (params) => postUpload("/batchOperate/uploadUpdate", params), // 导入修改
    uploadDelete: (params) => postUpload("/batchOperate/uploadDelete", params), // 导入修改
    uploadUpdateOrCreate: (params) => postUpload("/batchOperate/uploadUpdateOrCreate", params), // 导入新增/修改
    // 其他上传
    uploadOther: (params) => postUpload("/other/syncRdTestItem", params),

    // 用于金蝶批量处理
    // 下载模板
    downloadK3InsertTemplate: (params) => downFile("/batchOperate/downloadK3InsertTemplate", params), //下载新增模板
    downloadK3UpdateTemplate: (params) => downFile("/batchOperate/downloadK3UpdateTemplate", params), //下载修改模板
    downloadK3ErrorMessage: (params) => downFile("/batchOperate/downloadK3ErrorMessage", params), //下载错误信息
    // 上传接口
    uploadK3Insert: (params) => postUpload("/batchOperate/uploadK3Insert", params), // 导入新增
    uploadK3Update: (params) => postUpload("/batchOperate/uploadK3Update", params), // 导入修改
    // 公共接口
    fieldSave: (params) => post("/field/save", params), //字段保存
    searchAccounts: (params) => post("/search/accounts", params), //账户搜索下拉 上级名称搜索下拉 需方搜索下拉
    searchTerminalAuthorizations: (params) => post("/search/terminalAuthorizations", params), //终端授权下拉搜索
    searchFlows: (params) => post("/search/flows", params), //符合条件的正流向下拉，用于冲销负流向
    searchAssignmentObject: (params) => post("/search/assignmentObject", params),
    accountCategory: (params) => post("/dropdown/accountCategory", params),
    accountType: (params) => post("/dropdown/accountType", params), //账户类型下拉
    provinces: (params) => post("/dropdown/provinces", params), //省份下拉
    provinceCities: (params) => post("/dropdown/provinceCities", params), //省份城市级联下拉
    materialTypes: (params) => post("/dropdown/materialTypes", params), //物料类型下拉
    materials: (params) => post("/dropdown/materials", params), //物料下拉
    identityTypes: (params) => post("/dropdown/identityType", params), //身份类型下拉
    accountConfidence: (params) => post("/dropdown/accountConfidence", params), //账户确信度
    confidenceSimple: (params) => post("/dropdown/confidenceSimple", params), //账户确信度
    accountAliasVerification: (params) => post("/dropdown/accountAliasVerification", params), //账户别名验证状态

    cities: (params) => post("/dropdown/cities", params), //城市下拉
    districts: (params) => post("/dropdown/districts", params), //区县下拉
    searchContCacts: (params) => post("/search/contacts", params), //联系人搜索下拉
    searchPartners: (params) => post("/search/partners", params), //合作方搜索下拉
    productLicencesDropdown: (params) => post("/dropdown/productLicences", params), //批文列表下拉
    dropdownProducts: (params) => post("/dropdown/products", params), //产品下拉列表
    dropdownBankRelType: (params) => post("/dropdown/bankRelType", params), //银行账户关联类型
    partnerSchemes: (params) => post("/dropdown/partnerSchemes", params), //合作规划code列表
    partnerPriceProducts: (params) => post("/dropdown/partnerPriceProducts", params), //存在合作价格的产品下拉列表
    dealType: (params) => post("/dropdown/dealType", params), //交易明细类型下拉
    partnerCurrentType: (params) => post("/dropdown/partnerCurrentType", params), //交易明细类型下拉（针对合作往来和预算项目）
    decisionRank: (params) => post("/dropdown/decisionRank", params), //职位等级下拉
    agencyType: (params) => post("/dropdown/agencyType", params), //代理类型下拉
    procedureRelType: (params) => post("/dropdown/procedureRelType", params), //流程行对象类型下拉
    procedureLineDetailsList: (params) => post("/procedureLine/lists", params), //流程行详情
    procedureMode: (params) => post("/dropdown/procedureMode", params), //流程详情模式下拉列表
    budgetSubjectType: (params) => post("/dropdown/budgetSubjectType", params), //预算科目类型下拉
    budgetSubjectAccountingAttribute: (params) => post("/dropdown/budgetSubjectAccountingAttribute", params), //预算科目会计属性下拉
    budgetSubjectAssistance: (params) => post("/dropdown/budgetSubjectAssistance", params), //预算科目辅助类型下拉
    budgetDepartment: (params) => post("/dropdown/department", params), //预算科目部门下拉 部门下拉
    dropdownAdmins: (params) => post("/dropdown/admins", params), //用户下拉
    dropdownPartners: (params) => post("/dropdown/partners", params), //合作方下拉
    dropdownBankAccounts: (params) => post("/dropdown/bankAccounts", params), //银行账户下拉
    getQiNiuToken: (params) => post("/public/getQiNiuToken", params), //七牛上传接口
    getQiNiuDownloadToken: (params) => post("/public/getQiNiuDownloadToken", params), //七牛下载接口
    dropdownApprovalStatus: (params) => post("/dropdown/approvalStatus", params), //合作方下拉
    dropdownCommonStatus: (params) => post("/dropdown/commonStatus", params), //公用状态下拉
    dropdownTerminalAuthorizationType: (params) => post("/dropdown/terminalAuthorizationType", params), //终端授权类型
    dropdownAdminType: (params) => post("/dropdown/adminType", params), //用户类型下拉
    dropdownPersonStatus: (params) => post("/dropdown/personStatus", params), //人员状态下拉
    dropdownOpenCloseStatus: (params) => post("/dropdown/openCloseStatus", params), //开放关闭下拉
    dropdownHierarchyPersonStatus: (params) => post("/dropdown/hierarchyPersonStatus", params), //任职记录状态
    dropdownRoles: (params) => post("/dropdown/roles", params), // 角色下拉
    businessScopes: (params) => post("/dropdown/businessScopes", params), // 业务范围下拉
    businessTypes: (params) => post("/dropdown/businessTypes", params), // 业务类型下拉
    operationTypes: (params) => post("/dropdown/operationTypes", params), // 运营类型下拉
    flowOperationTypes: (params) => post("/dropdown/flowOperationTypes", params), // 运营类型下拉（流向）
    teamRole: (params) => post("/dropdown/teamRole", params), // 团队角色下拉
    gender: (params) => post("/dropdown/gender", params), // 性别
    nation: (params) => post("/dropdown/nation", params), // 民族
    politicalStatus: (params) => post("/dropdown/politicalStatus", params), // 政治面貌
    maritalStatus: (params) => post("/dropdown/maritalStatus", params), // 团队婚姻状况角色下拉
    yesOrNo: (params) => post("/dropdown/yesOrNo", params), // 是否
    passType: (params) => post("/dropdown/passType", params), // 转正类型
    leftDateType: (params) => post("/dropdown/leftDateType", params), // 离职类型
    path: (params) => post("/dropdown/path", params), // 发展通道
    personRank: (params) => post("/dropdown/personRank", params), // 职级
    concentration: (params) => post("/dropdown/concentration", params), // 专注度
    dropdownKdStatus: (params) => post("/dropdown/kdStatus", params), // 金蝶状态下拉
    dropdownTransactionType: (params) => post("/dropdown/transactionType", params), // 业务类型下拉
    dropdownPromotionType: (params) => post("/dropdown/promotionType", params), // 推广类型下拉
    dropdownSalesBasis: (params) => post("/dropdown/salesBasis", params), // 纯销依据下拉
    dropdownFlowType: (params) => post("/dropdown/flowType", params), // 流向类型下拉
    dropdownPersonContractType: (params) => post("/dropdown/personContractType", params), // 合同类型下拉
    dropdownPersonContractStatus: (params) => post("/dropdown/personContractStatus", params), // 合同状态下拉
    dropdownEmploymentForm: (params) => post("/dropdown/employmentForm", params), // 用工形式下拉
    dropdownAccountByParams: (params) => post("/dropdown/accountByParams", params), // 账户下拉（小数据范围、多过滤条件）
    dropdownExperienceClassification: (params) => post("/dropdown/experienceClassification", params), // 经历类别
    dropdownExperienceType: (params) => post("/dropdown/experienceType", params), // 经历类型
    dropdownEducational: (params) => post("/dropdown/educational", params), // 学历
    dropDownTransactionFlowPendingType: (params) => post("/dropdown/transactionFlowPendingType", params), // 反匹配待处理关联类型
    dropDownTransactionFlowPendingProcessType: (params) => post("/dropdown/transactionFlowPendingProcessType", params), // 反匹配待处理处理类型
    dropDownTransactionFlowPendingProcessStatus: (params) => post("/dropdown/transactionFlowPendingProcessStatus", params), // 反匹配待处理处理状态
    dropdownTransactionFlowRelType: (params) => post("/dropdown/transactionFlowRelType", params), // 业务流向关联类型
    dropdownRoleType: (params) => post("/dropdown/roleType", params), // 角色类型
    dropdownRoleFields: (params) => post("/dropdown/roleFields", params), // 角色字段对象类型
    dropdownRoleRows: (params) => post("/dropdown/roleRows", params), // 角色行级对象类型
    dropdownPartnerStatus: (params) => post("/dropdown/partnerStatus", params), // 合作状态
    dropdownPpaState: (params) => post("/dropdown/ppaState", params), // PPA重算状态
    dropdownPpaType: (params) => post("/dropdown/ppaType", params), // PPA重算状态
    dropdownDataStatusSign: (params) => post("/dropdown/dataStatusSign", params),
    dropdownStateType: (params) => post("/dropdown/stateType", params),
    dropdownBusinessUnits: (params) => post("/dropdown/businessUnits", params),
    dropdownBusinessUnitType: (params) => post("/dropdown/businessUnitType", params),
    dropdownReceivableAdjustmentDateBasis: (params) => post("/dropdown/receivableAdjustmentDateBasis", params),
    dropdownReceivableCalculationBasis: (params) => post("/dropdown/receivableCalculationBasis", params),
    dropdownReceivableAllotmentStatus: (params) => post("/dropdown/receivableAllotmentStatus", params),
    dropdownReceivableAdjustmentType: (params) => post("/dropdown/receivableAdjustmentType", params),
    dropdownPerformanceUnit: (params) => post("/dropdown/performanceUnit", params),
    dropdownPerformanceUnitType: (params) => post("/dropdown/performanceUnitType", params),
    dropdownProductTypeCode: (params) => post("/dropdown/productTypeCode", params),
    dropdownPersonPerformanceLineTypeCode: (params) => post("/dropdown/personPerformanceLineTypeCode", params),
    dropdownProductPeriodType: (params) => post("/dropdown/productPeriodType", params),
    dropdownProductLicencePeriodType: (params) => post("/dropdown/productLicencePeriodType", params),
    dropdownProductGroupCode: (params) => post("/dropdown/productGroupCode", params),
    dropdownCommodityFlowApplicable: (params) => post("/dropdown/commodityFlowApplicable", params),
    dropdownPerformanceBasis: (params) => post("/dropdown/performanceBasis", params),
    dropdownAssignmentObjectType: (params) => post("/dropdown/assignmentObjectType", params),
    dropdownReceiptLockSign: (params) => post("/dropdown/receiptLockSign", params),
    dropdownReceiptType: (params) => post("/dropdown/receiptType", params),
    dropdownReceivableLockSign: (params) => post("/dropdown/receivableLockSign", params),
    dropdownTargetAchievementRateBasis: (params) => post("/dropdown/targetAchievementRateBasis", params),
    dropdownBaseBasis: (params) => post("/dropdown/baseBasis", params),
    dropdownBaseType: (params) => post("/dropdown/baseType", params),
    dropdownPerformanceType: (params) => post("/dropdown/performanceType", params),
    dropdownPerformancePersonQuotaType: (params) => post("/dropdown/performancePersonQuotaType", params),
    dropdownPerformancePersonBaseType: (params) => post("/dropdown/performancePersonBaseType", params),
    dropdownPerformancePersonConfig: (params) => post("/dropdown/performancePersonConfig", params),
    dropdownPerformanceTypeSign: (params) => post("/dropdown/performanceTypeSign", params),
    dropdownPerformanceLockSign: (params) => post("/dropdown/performanceLockSign", params),
    dropdownPerformanceBaseFactorSign: (params) => post("/dropdown/performanceBaseFactorSign", params),
    dropdownPartnerProductAccount: (params) => post("/dropdown/partnerProductAccount", params),
    dropdownParameterFunction: (params) => post("/dropdown/parameterFunction", params),
    dropdownParameterProgress: (params) => post("/dropdown/parameterProgress", params),
    dropdownBiAccounts: (params) => post("/dropdown/biAccounts", params), // powerbi账户下拉
    dropdownPersonPerformance: (params) => post("/dropdown/personPerformance", params),
    dropdownLogisticsType: (params) => post("/dropdown/logisticsType", params),
    dropdownLogisticsStatus: (params) => post("/dropdown/logisticsStatus", params),
    dropdownProvinceSign: (params) => post("/dropdown/provinceSign", params),
    dropdownPpaLockSign: (params) => post("/dropdown/ppaLockSign", params),


    //登陆 权限相关
    login: (params) => post("/public/login", params), //登录
    sendSmsCode: (params) => post("/public/sendSmsCode", params), //发送验证码
    forget: (params) => post("/public/forget", params), //返回登录
    updatePassword: (params) => post("/admin/updatePassword", params), //修改密码
    logout: (params) => post("/public/loginOut", params), //退出登录
    taskQueueMessage: (params) => post("/public/taskQueueMessage", params),
    adminLists: (params) => post("/admin/lists", params), //后台用户列表
    adminDetail: (params) => post("/admin/detail", params), //后台用户详情
    adminDelete: (params) => post("/admin/delete", params), //用户删除
    adminUpdate: (params) => post("/admin/update", params), //编辑单个用户
    adminBatchDelete: (params) => post("/admin/batchDelete", params), //删除单个用户
    adminInsert: (params) => post("/admin/insert", params), //新增角色
    resetPassword: (params) => post("/admin/reSetPassword", params), //重置密码
    roleLists: (params) => post("/role/lists", params), //角色列表
    roleInsert: (params) => post("/role/insert", params), //新增角色
    roleUpdate: (params) => post("/role/update", params), //修改角色
    batchDelete: (params) => post("/role/batchDelete", params), //删除角色
    getPermissionsWithRole: (params) => post("/permission/getPermissionsWithRole", params), //获取角色下的权限
    savePermissions: (params) => post("/role/savePermissions", params), //设置角色下的权限
    getRolesWithAdmin: (params) => post("/role/getRolesWithAdmin", params), //获取用户拥有的角色
    // 角色字段
    roleFieldLists: (params) => post("/roleField/lists", params),
    roleFieldsave: (params) => post("/roleField/save", params),
    // 角色行级
    roleRowLists: (params) => post("/roleRow/lists", params),
    roleRowsave: (params) => post("/roleRow/save", params),

    saveRoles: (params) => post("/admin/saveRoles", params), //获给后台用户设置角色
    permissionLists: (params) => post("/permission/lists", params), //权限列表
    getPermissionDropDown: (params) => post("/permission/getPermissionDropDown", params), //权限下拉列表
    permissionInsert: (params) => post("/permission/insert", params), //新增权限
    permissionBatchDelete: (params) => post("permission/batchDelete", params), //删除权限
    permissionUpdate: (params) => post("/permission/update", params), //删除权限
    organizeLists: (params) => post("/organize/lists", params), //组织架构
    dropdownPeriod: (params) => post("/dropdown/period", params), //分配期间下拉
    monthPeriods: (params) => post("/dropdown/monthPeriods", params), //月度期间下拉（当前周期前后10年）
    dropChannelType: (params) => post("/dropdown/channelType", params), // 账户渠道类型


    // 流向相关
    commodityFlowSourceLists: (params) => post("/commodityFlow/lists", params), //流向列表
    commodityFlowSourceListsDownFile: (params) => downFile("/commodityFlow/lists", params), //流向列表下载
    commodityFlowDetail: (params) => post("/commodityFlow/detail", params), //流向详情
    commodityFlowInsert: (params) => post("/commodityFlow/insert", params), //流向新增
    commodityFlowDelete: (params) => post("/commodityFlow/delete", params), //流向删除
    commodityFlowUpdate: (params) => post("/commodityFlow/update", params), //流向更新
    commodityFlowSourceTag: (params) => post("/dropdown/commodityFlowSourceTag", params), //流向标签下拉
    commodityFlowSourceFlush: (params) => postLong("/commodityFlow/flush", params), //刷新流向
    commodityFlowSourceFlushIsPpa: (params) => postLong("/commodityFlow/flushIsPpa", params), //刷新是否PPA流向
    flushFlowPerformanceUnitCode: (params) => postLong("/commodityFlow/flushPerformanceUnitCode", params), // 刷新绩效单元
    flushFlowBusinessUnitCode: (params) => postLong("/commodityFlow/flushBusinessUnitCode", params), // 刷新业务单元
    stockSourceLists: (params) => post("/commodityStock/lists", params), //库存列表
    stockSourcePrincipalLists: (params) => post("/commodityStock/principalLists", params), //库存负责人列表
    stockSourceDetail: (params) => post("/commodityStock/detail", params), //库存详情
    stockSourceInsert: (params) => post("/commodityStock/insert", params), //库存新增
    stockSourceUpdate: (params) => post("/commodityStock/update", params), //库存修改
    stockSourceDelete: (params) => post("/commodityStock/delete", params), //库存删除
    stockSourcePrincipalUpdate: (params) => post("/commodityStock/principalUpdate", params), //负责人修改库存
    stockSourceListsDownFile: (params) => downFile("/commodityStock/lists", params), //库存列表下载
    stockSourceFlush: (params) => postLong("/commodityStock/flush", params), //刷新库存
    stockProductList: (params) => post("/commodityStock/toRepairProductLists", params), //待关联产品列表
    stockOwnerList: (params) => post("/commodityStock/toRepairOwnerLists", params), //待关联产品所有者列表
    flowSourceConfigList: (params) => post("/commodityFlowConfig/lists", params), //流向凭据配置列表
    flowSourceConfigListDownFile: (params) => downFile("/commodityFlowConfig/lists", params), //流向凭据配置
    flowSourceConfigDetail: (params) => post("/commodityFlowConfig/detail", params), //流向凭据配置详情
    flowSourceConfigInsert: (params) => post("/commodityFlowConfig/insert", params), //流向凭据配置新增
    flowSourceConfigUpdate: (params) => post("/commodityFlowConfig/update", params), //流向凭据配置修改
    flowSourceConfigDelete: (params) => post("/commodityFlowConfig/delete", params), //流向凭据配置删除
    flowProductList: (params) => post("/commodityFlow/toRepairProductLists", params), //待关联产品列表
    flowSupplierList: (params) => post("/commodityFlow/toRepairSupplierLists", params), //待关联供方列表
    flowDemanderList: (params) => post("/commodityFlow/toRepairDemanderLists", params), //待关联需方列表
    flowDemanderListDownFile: (params) => downFile("/commodityFlow/toRepairDemanderLists", params), //待关联需方列表下载

    // 流向冲销相关（正负冲销）
    flowNegativeList: (params) => post("/commodityFlow/negativeLists", params), //负流向待处理列表
    flowNegativeWriteOff: (params) => postLong("/commodityFlowWriteOff/writeOff", params), //冲销负流向
    flowNegativeProcess: (params) => postLong("/commodityFlowWriteOff/batchProcess", params), //处理待处理
    flowNegativeWriteoffLists: (params) => post("/commodityFlowWriteOff/lists", params), //负流向已冲销列表
    flowNegativeWriteoffListsDownFile: (params) => downFile("/commodityFlowWriteOff/lists", params), //负流向已冲销列表下载

    // 流向凭据相关
    commodityFlowSourceCredentialLists: (params) => post("/commodityFlowSourceCredential/lists", params), //流向凭据列表
    commodityFlowSourceCredentialDownFile: (params) => downFile("/commodityFlowSourceCredential/lists", params), //流向列表下载
    dropdownCredentialStatus: (params) => post("/dropdown/credentialStatus", params), //凭据状态下拉接口
    commodityFlowSourceCredentialDetail: (params) => post("/commodityFlowSourceCredential/detail", params), //流向凭据详情
    commodityFlowSourceCredentialDelete: (params) => post("/commodityFlowSourceCredential/delete", params), //删除流向凭据
    commodityFlowSourceCredentialInsert: (params) => post("/commodityFlowSourceCredential/insert", params), //新增流向凭据
    commodityFlowSourceCredentialUpdate: (params) => post("/commodityFlowSourceCredential/update", params), //修改流向凭据

    // 业务相关
    transactionLists: (params) => post("/transaction/lists", params), // 业务列表
    transactionListsDownFile: (params) => downFile("/transaction/lists", params), //业务列表下载
    transactionDetail: (params) => post("/transaction/detail", params),
    transactionSyncFromK3: (params) => postLong("/transaction/syncFromK3", params), // 同步金蝶业务到CRM
    transactionReceivableSyncFromK3: (params) => postLong("/transaction/syncReceivableFromK3", params), // 同步金蝶业务应收核销信息到CRM
    transactionMatchPartnerCurrent: (params) => postLong("/transaction/matchPartnerCurrent", params), // 业务匹配往来
    transactionMatchFlow: (params) => postLong("/transaction/matchFlow", params), // 业务匹配流向
    // 物流跟踪
    transactionLogisticsLists: (params) => post("/transactionLogistics/lists", params), // 物流跟踪列表
    transactionLogisticsListsDownFile: (params) => downFile("/transactionLogistics/lists", params), //物流跟踪列表下载
    transactionLogisticsDetail: (params) => post("/transactionLogistics/detail", params),
    transactionLogisticsSyncFromK3: (params) => postLong("/transactionLogistics/syncFromK3", params), // 同步金蝶物流跟踪到CRM
    // 应收相关
    receivableLists: (params) => post("/receivable/lists", params), // 应收列表
    receivableListsDownFile: (params) => downFile("/receivable/lists", params), //应收列表下载
    receivableDetail: (params) => post("/receivable/detail", params),
    receivableUpdate: (params) => post("/receivable/update", params),
    receivableSyncFromK3: (params) => postLong("/receivable/syncFromK3", params), // 同步金蝶应收到CRM
    receivableFlushLoss: (params) => postLong("/receivable/flushLoss", params), // 刷新损失信息
    deleteAdjustment: (params) => postLong("/receivable/deleteAdjustment", params), // 删除调整单
    flushALK: (params) => postLong("/receivable/flushALK", params), // 刷新A库调整
    flushClearing: (params) => postLong("/receivable/flushClearing", params), // 刷新清账信息
    flushPerformanceUnitCode: (params) => postLong("/receivable/flushPerformanceUnitCode", params), // 刷新绩效单元

    // 绩效相关
    receiptLists: (params) => post("/receipt/lists", params),
    receiptListsDownFile: (params) => downFile("/receipt/lists", params),
    receiptDetail: (params) => post("/receipt/detail", params),
    receiptUpdate: (params) => post("/receipt/update", params),
    //
    performanceAssignmentLists: (params) => post("/performanceAssignment/lists", params),
    performanceAssignmentListsDownFile: (params) => downFile("/performanceAssignment/lists", params),
    performanceAssignmentDetail: (params) => post("/performanceAssignment/detail", params),
    performanceAssignmentInsert: (params) => post("/performanceAssignment/insert", params),
    performanceAssignmentUpdate: (params) => post("/performanceAssignment/update", params),
    performanceAssignmentDelete: (params) => post("/performanceAssignment/delete", params),
    performanceAssignmentFlush: (params) => post("/performanceAssignment/refresh", params),
    //
    performanceAssignmentLineLists: (params) => post("/performanceAssignmentLine/lists", params),
    performanceAssignmentLineSave: (params) => post("/performanceAssignmentLine/updateOrCreate", params),
    //
    performanceUnitLists: (params) => post("/performanceUnit/lists", params),
    performanceUnitListsDownFile: (params) => downFile("/performanceUnit/lists", params),
    performanceUnitDetail: (params) => post("/performanceUnit/detail", params),
    performanceUnitInsert: (params) => post("/performanceUnit/insert", params),
    performanceUnitUpdate: (params) => post("/performanceUnit/update", params),
    performanceUnitDelete: (params) => post("/performanceUnit/delete", params),
    performanceUnitRecalculate: (params) => postLong("/performanceUnit/recalculate", params),
    performanceUnitFlushRelease: (params) => postLong("/performanceUnit/flushRelease", params),
    //
    performanceUnitSnapshotLists: (params) => post("/performanceUnitSnapshot/lists", params),
    performanceUnitSnapshotListsDownFile: (params) => downFile("/performanceUnitSnapshot/lists", params),
    performanceUnitSnapshotDetail: (params) => post("/performanceUnitSnapshot/detail", params),
    //
    performancePersonConfigLists: (params) => post("/performancePersonConfig/lists", params),
    performancePersonConfigListsDownFile: (params) => downFile("/performancePersonConfig/lists", params),
    performancePersonConfigDetail: (params) => post("/performancePersonConfig/detail", params),
    performancePersonConfigInsert: (params) => post("/performancePersonConfig/insert", params),
    performancePersonConfigUpdate: (params) => post("/performancePersonConfig/update", params),
    performancePersonConfigDelete: (params) => post("/performancePersonConfig/delete", params),
    performancePersonConfigRecalculate: (params) => postLong("/performancePersonConfig/recalculate", params),
    performancePersonConfigSnapshot: (params) => postLong("/performancePersonConfig/snapshot", params),
    //
    performancePersonLists: (params) => post("/performancePerson/lists", params),
    performancePersonListsDownFile: (params) => downFile("/performancePerson/lists", params),
    performancePersonDetail: (params) => post("/performancePerson/detail", params),
    performancePersonInsert: (params) => post("/performancePerson/insert", params),
    performancePersonUpdate: (params) => post("/performancePerson/update", params),
    performancePersonDelete: (params) => post("/performancePerson/delete", params),
    //
    performancePersonSnapshotLists: (params) => post("/performancePersonSnapshot/lists", params),
    performancePersonSnapshotListsDownFile: (params) => downFile("/performancePersonSnapshot/lists", params),
    performancePersonSnapshotDetail: (params) => post("/performancePersonSnapshot/detail", params),
    //
    performanceProductLists: (params) => post("/performanceProduct/lists", params),
    performanceProductListsDownFile: (params) => downFile("/performanceProduct/lists", params),
    performanceProductDetail: (params) => post("/performanceProduct/detail", params),
    performanceProductInsert: (params) => post("/performanceProduct/insert", params),
    performanceProductUpdate: (params) => post("/performanceProduct/update", params),
    performanceProductDelete: (params) => post("/performanceProduct/delete", params),
    //
    performanceProductLineLists: (params) => post("/performanceProductLine/lists", params),
    performanceProductLineListsDownFile: (params) => downFile("/performanceProductLine/lists", params),
    performanceProductLineDetail: (params) => post("/performanceProductLine/detail", params),
    //
    consumptionLineLists: (params) => post("/consumptionLine/lists", params),
    consumptionLineListsDownFile: (params) => downFile("/consumptionLine/lists", params),
    consumptionLineDetail: (params) => post("/consumptionLine/detail", params),
    //
    consumptionLists: (params) => post("/consumption/lists", params),
    consumptionListsDownFile: (params) => downFile("/consumption/lists", params),
    consumptionDetail: (params) => post("/consumption/detail", params),
    // 绩效归属
    performanceAttributionLists: (params) => post("/performanceAttribution/lists", params),
    performanceAttributionListsDownFile: (params) => downFile("/performanceAttribution/lists", params),
    performanceAttributionDetail: (params) => post("/performanceAttribution/detail", params),
    performanceAttributionInsert: (params) => post("/performanceAttribution/insert", params),
    performanceAttributionUpdate: (params) => post("/performanceAttribution/update", params),
    performanceAttributionDelete: (params) => post("/performanceAttribution/delete", params),
    // 人员绩效
    personPerformanceLists: (params) => post("/personPerformance/lists", params),
    personPerformanceListsDownFile: (params) => downFile("/personPerformance/lists", params),
    personPerformanceDetail: (params) => post("/personPerformance/detail", params),
    personPerformanceInsert: (params) => post("/personPerformance/insert", params),
    personPerformanceUpdate: (params) => post("/personPerformance/update", params),
    personPerformanceDelete: (params) => post("/personPerformance/delete", params),
    personPerformanceRecalculate: (params) => postLong("/personPerformance/recalculate", params),
    // 人员绩效审批
    personPerformanceConfirmLists: (params) => post("/personPerformanceConfirm/lists", params),
    personPerformanceConfirmListsDownFile: (params) => downFile("/personPerformanceConfirm/lists", params),
    personPerformanceConfirmDetail: (params) => post("/personPerformanceConfirm/detail", params),
    personPerformanceConfirmInsert: (params) => post("/personPerformanceConfirm/insert", params),
    personPerformanceConfirmUpdate: (params) => post("/personPerformanceConfirm/update", params),
    personPerformanceConfirmDelete: (params) => post("/personPerformanceConfirm/delete", params),
    // 人员绩效调整
    personPerformanceLineLists: (params) => post("/personPerformanceLine/lists", params),
    personPerformanceLineListsDownFile: (params) => downFile("/personPerformanceLine/lists", params),
    personPerformanceLineDetail: (params) => post("/personPerformanceLine/detail", params),
    personPerformanceLineInsert: (params) => post("/personPerformanceLine/insert", params),
    personPerformanceLineUpdate: (params) => post("/personPerformanceLine/update", params),
    personPerformanceLineDelete: (params) => post("/personPerformanceLine/delete", params),
    // 业务单元
    businessUnitLists: (params) => post("/businessUnit/lists", params),
    businessUnitListsDownFile: (params) => downFile("/businessUnit/lists", params),
    businessUnitDetail: (params) => post("/businessUnit/detail", params),
    businessUnitInsert: (params) => post("/businessUnit/insert", params),
    businessUnitUpdate: (params) => post("/businessUnit/update", params),
    businessUnitDelete: (params) => post("/businessUnit/delete", params),
    // 应收调整相关
    receivableAdjustmentLists: (params) => post("/receivableAdjustment/lists", params),
    receivableAdjustmentListsDownFile: (params) => downFile("/receivableAdjustment/lists", params),
    receivableAdjustmentDetail: (params) => post("/receivableAdjustment/detail", params),
    receivableAdjustmentInsert: (params) => post("/receivableAdjustment/insert", params),
    receivableAdjustmentUpdate: (params) => post("/receivableAdjustment/update", params),
    receivableAdjustmentDelete: (params) => post("/receivableAdjustment/delete", params),
    receivableAdjustmentAllotment: (params) => postLong("/receivableAdjustment/allotment", params),
    receivableAdjustmentApproval: (params) => postLong("/receivableAdjustment/approval", params),
    receivableAdjustmentRevoke: (params) => postLong("/receivableAdjustment/revoke", params),
    // 一次调用把应收和流向两张表都处理了（后端按 SF 的 Type__c 分流），应收调整和流向调整两个列表页共用。
    // URL 挂在 receivableAdjustment 下是历史原因，也因此权限表里只需要配这一条。
    adjustmentSyncFromSf: (params) => postLong("/receivableAdjustment/syncFromSf", params),
    receivableAdjustmentLineLists: (params) => post("/receivableAdjustmentLine/lists", params),
    receivableAdjustmentLineListsDownFile: (params) => downFile("/receivableAdjustmentLine/lists", params),
    // 流向调整相关
    commodityFlowAdjustmentLists: (params) => post("/commodityFlowAdjustment/lists", params),
    commodityFlowAdjustmentListsDownFile: (params) => downFile("/commodityFlowAdjustment/lists", params),
    commodityFlowAdjustmentDetail: (params) => post("/commodityFlowAdjustment/detail", params),
    commodityFlowAdjustmentInsert: (params) => post("/commodityFlowAdjustment/insert", params),
    commodityFlowAdjustmentUpdate: (params) => post("/commodityFlowAdjustment/update", params),
    commodityFlowAdjustmentDelete: (params) => post("/commodityFlowAdjustment/delete", params),
    commodityFlowAdjustmentAllotment: (params) => postLong("/commodityFlowAdjustment/allotment", params),
    commodityFlowAdjustmentApproval: (params) => postLong("/commodityFlowAdjustment/approval", params),
    commodityFlowAdjustmentRevoke: (params) => postLong("/commodityFlowAdjustment/revoke", params),
    commodityFlowAdjustmentLineLists: (params) => post("/commodityFlowAdjustmentLine/lists", params),
    commodityFlowAdjustmentLineListsDownFile: (params) => downFile("/commodityFlowAdjustmentLine/lists", params),
    // 合作产品路径（PPA）
    partnerProductAccountLists: (params) => post("/partnerProductAccount/lists", params),
    partnerProductAccountListsDownFile: (params) => downFile("/partnerProductAccount/lists", params),
    partnerProductAccountInsert: (params) => post("/partnerProductAccount/insert", params),
    partnerProductAccountUpdate: (params) => post("/partnerProductAccount/update", params),
    partnerProductAccountDelete: (params) => post("/partnerProductAccount/delete", params),
    partnerProductAccountDetail: (params) => post("/partnerProductAccount/detail", params),
    partnerProductAccountFlushBusinessDate: (params) => postLong("/partnerProductAccount/flushBusinessDate", params),
    //
    partnerProductAccountPeriodLists: (params) => post("/partnerProductAccountPeriod/lists", params),
    partnerProductAccountPeriodListsDownFile: (params) => downFile("/partnerProductAccountPeriod/lists", params),
    partnerProductAccountPeriodInsert: (params) => post("/partnerProductAccountPeriod/insert", params),
    partnerProductAccountPeriodUpdate: (params) => post("/partnerProductAccountPeriod/update", params),
    partnerProductAccountPeriodDelete: (params) => post("/partnerProductAccountPeriod/delete", params),
    partnerProductAccountPeriodDetail: (params) => post("/partnerProductAccountPeriod/detail", params),
    // 合作产品路径（初始化信息）
    commodityFlowStateInitLists: (params) => post("/commodityFlowStateInit/lists", params),
    commodityFlowStateInitListsDownFile: (params) => downFile("/commodityFlowStateInit/lists", params),
    commodityFlowStateInitInsert: (params) => post("/commodityFlowStateInit/insert", params),
    commodityFlowStateInitUpdate: (params) => post("/commodityFlowStateInit/update", params),
    commodityFlowStateInitDelete: (params) => post("/commodityFlowStateInit/delete", params),
    commodityFlowStateInitDetail: (params) => post("/commodityFlowStateInit/detail", params),
    commodityFlowStateInitInsertDefaultData: (params) => post("/commodityFlowStateInit/insertDefaultData", params),
    // 流向状态
    commodityFlowStateLists: (params) => post("/commodityFlowState/lists", params),
    commodityFlowStateListsDownFile: (params) => downFile("/commodityFlowState/lists", params),
    commodityFlowStateRecalculate: (params) => postLong("/commodityFlowState/recalculate", params),
    commodityFlowStateRecalculateFlowExtension: (params) => postLong("/commodityFlowState/recalculateFlowExtension", params),
    commodityFlowStateToSf: (params) => postLong("/commodityFlowState/toSf", params),
    commodityFlowStateDetail: (params) => post("/commodityFlowState/detail", params),

    // 合作产品期间路径
    transactionConfigLists: (params) => post("/transactionConfig/lists", params),
    transactionConfigListsDownFile: (params) => downFile("/transactionConfig/lists", params),
    transactionConfigInsert: (params) => post("/transactionConfig/insert", params),
    transactionConfigUpdate: (params) => post("/transactionConfig/update", params),
    transactionConfigDelete: (params) => post("/transactionConfig/delete", params),
    transactionConfigDetail: (params) => post("/transactionConfig/detail", params),
    transactionConfigMatch: (params) => postLong("/transactionConfig/match", params),
    transactionConfigMatchFlow: (params) => postLong("/transactionConfig/matchFlow", params),
    transactionConfigInitLine: (params) => postLong("/transactionConfig/initLine", params),
    transactionConfigSyncFromSf: (params) => postLong("/transactionConfig/syncFromSf", params),
    transactionConfigDisable: (params) => post("/transactionConfig/disable", params),

    // 合作产品期间路径明细
    transactionConfigDetailLists: (params) => post("/transactionConfigDetail/lists", params),
    transactionConfigDetailListsDownFile: (params) => downFile("/transactionConfigDetail/lists", params),
    transactionConfigDetailInsert: (params) => post("/transactionConfigDetail/insert", params),
    transactionConfigDetailUpdate: (params) => post("/transactionConfigDetail/update", params),
    transactionConfigDetailDelete: (params) => post("/transactionConfigDetail/delete", params),
    transactionConfigDetailDetail: (params) => post("/transactionConfigDetail/detail", params),

    // 终端授权
    terminalAuthorizationLists: (params) => post("/terminalAuthorization/lists", params), //终端授权列表
    terminalAuthorizationListsDownFile: (params) => downFile("/terminalAuthorization/lists", params), //终端授权列表下载
    terminalAuthorizationInsert: (params) => post("/terminalAuthorization/insert", params), //终端授权新增
    terminalAuthorizationUpdate: (params) => post("/terminalAuthorization/update", params), //修改终端授权
    terminalAuthorizationDelete: (params) => post("/terminalAuthorization/delete", params), //终端授权删除
    terminalAuthorizationDetail: (params) => post("/terminalAuthorization/detail", params), //终端授权详情
    terminalAuthorizationMatch: (params) => postLong("/terminalAuthorization/match", params), //终端授权匹配流向（增量）
    terminalAuthorizationDisable: (params) => post("/terminalAuthorization/disable", params), //终端授权禁用
    terminalAuthorizationSubmit: (params) => post("/terminalAuthorization/submit", params), //终端授权提交

    // 流向商业配置
    commodityFlowConfig01Lists: (params) => post("/commodityFlowConfig01/lists", params),
    commodityFlowConfig01ListsDownFile: (params) => downFile("/commodityFlowConfig01/lists", params),
    commodityFlowConfig01Insert: (params) => post("/commodityFlowConfig01/insert", params),
    commodityFlowConfig01Update: (params) => post("/commodityFlowConfig01/update", params),
    commodityFlowConfig01Delete: (params) => post("/commodityFlowConfig01/delete", params),
    commodityFlowConfig01Detail: (params) => post("/commodityFlowConfig01/detail", params),
    commodityFlowConfig01Match: (params) => postLong("/commodityFlowConfig01/match", params),
    commodityFlowConfig01Disable: (params) => post("/commodityFlowConfig01/disable", params),
    commodityFlowConfig01FlowLists: (params) => post("/commodityFlowConfig01/toRepairFlowLists", params),
    commodityFlowConfig01FlowListsDownFile: (params) => post("/commodityFlowConfig01/toRepairFlowLists", params),
    commodityFlowConfig01BatchInsert: (params) => post("/commodityFlowConfig01/batchInsert", params),

    // 反匹配待处理相关
    transactionFlowPendingLists: (params) => post("/transactionFlowPending/lists", params), // 反匹配待处理列表
    transactionFlowPendingListsDownFile: (params) => downFile("/transactionFlowPending/lists", params), // 反匹配待处理列表下载
    transactionFlowPendingDetail: (params) => post("/transactionFlowPending/detail", params), //反匹配待处理详情
    transactionFlowPendingDelete: (params) => post("/transactionFlowPending/delete", params), //反匹配待处理删除
    transactionFlowPendingUpdateOrCreate: (params) => post("/transactionFlowPending/updateOrCreate", params), //反匹配待处理新增或更新
    transactionFlowPendingBatchProcess: (params) => postLong("/transactionFlowPending/batchProcess", params), //反匹配待处理批量处理

    // 业务流向已匹配
    transactionFlowLists: (params) => post("/transactionFlow/lists", params),
    transactionFlowListsDownFile: (params) => downFile("/transactionFlow/lists", params),
    transactionFlowMatchPartnerCurrent: (params) => postLong("/transactionFlow/matchPartnerCurrent", params), // 业务流向匹配往来

    // 业务附件
    transactionAttachmentLists: (params) => post("/transactionAttachment/lists", params),
    transactionAttachmentListsDownFile: (params) => downFile("/transactionAttachment/lists", params),
    transactionAttachmentDetail: (params) => post("/transactionAttachment/detail", params),
    transactionAttachmentInsert: (params) => post("/transactionAttachment/insert", params),
    transactionAttachmentUpdate: (params) => post("/transactionAttachment/update", params),
    transactionAttachmentDelete: (params) => post("/transactionAttachment/delete", params),
    transactionAttachmentDownload: (params) => downFile("/transactionAttachment/download", params), // 下载附件

    // 银行账号相关
    bankAccountLists: (params) => post("/bankAccount/lists", params), // 银行账户列表
    bankAccountListsDownFile: (params) => downFile("/bankAccount/lists", params), // 银行账户列表下载
    bankAccountInsert: (params) => post("/bankAccount/insert", params), // 银行账户新增
    bankAccountUpdate: (params) => post("/bankAccount/update", params), //修改 银行账户
    bankAccountDelete: (params) => post("/bankAccount/delete", params), // 银行账户删除
    bankAccountDetail: (params) => post("/bankAccount/detail", params), // 银行账户详情

    // 账户相关
    accountLists: (params) => post("/account/lists", params), //账户列表
    accountListsDownFile: (params) => downFile("/account/lists", params), //账户列表下载
    accountInsert: (params) => post("/account/insert", params), //账户新增
    accountBatchInsert: (params) => postUpload("/account/batchInsert", params), // 批量导入新增
    accountUpdate: (params) => post("/account/update", params), //修改账户
    accountDelete: (params) => post("/account/delete", params), //账户删除
    accountDetail: (params) => post("/account/detail", params), //账户详情
    calcChannelTypeReference: (params) => post("/account/calcChannelTypeReference", params), // 计算渠道类型参考
    flushChannelType: (params) => post("/account/flushChannelType", params), // 刷新渠道类型
    flushChannelTypeReference: (params) => post("/account/flushChannelTypeReference", params), // 刷新渠道类型参考
    // 账户合并
    accountMergeLists: (params) => post("/account/accountMergeLists", params),
    accountMergeListsDownFile: (params) => downFile("/account/accountMergeLists", params),
    accountMergeSave: (params) => postLong("/account/accountMergeSave", params),

    accountAliasLists: (params) => post("/accountAlias/lists", params), //账户详情别名列表
    accountAliasInsert: (params) => post("/accountAlias/insert", params), //新增别名
    accountAliasUpdate: (params) => post("/accountAlias/update", params), //修改别名
    accountAliasDlete: (params) => post("/accountAlias/delete", params), //删除账户别名
    accountAliasForceDlete: (params) => post("/accountAlias/forceDelete", params), //强制删除账户别名
    accountAliasBatchSave: (params) => postLong("/accountAlias/batchSave", params), // 账户别名批量保存

    // 账户上级
    accountParentLists: (params) => post("/accountParent/lists", params),
    accountParentListsDownFile: (params) => downFile("/accountParent/lists", params),
    accountParentInsert: (params) => post("/accountParent/insert", params),
    accountParentUpdate: (params) => post("/accountParent/update", params),
    accountParentDelete: (params) => post("/accountParent/delete", params),
    accountParentDetail: (params) => post("/accountParent/detail", params),
    accountParentSubmit: (params) => post("/accountParent/submit", params),

    // 省市区相关
    districtLists: (params) => post("/district/lists", params), //省市区相关列表
    districtListsDownFile: (params) => downFile("/district/lists", params), //省市区相关列表下载

    //产品批文相关
    productLicenceLists: (params) => post("/productLicence/lists", params), //产品批文列表
    productLicenceDelete: (params) => post("/productLicence/delete", params), //产品批文删除
    productLicenceDownFile: (params) => downFile("/productLicence/lists", params), //产品批文下载
    productLicenceDetail: (params) => post("/productLicence/detail", params), //产品批文列表详情
    productLicenceUpdate: (params) => post("/productLicence/update", params), //产品批文列表修改
    productLicenceInsert: (params) => post("/productLicence/insert", params), //产品批文列表新增

    //产品单位相关
    productUnitLists: (params) => post("/productUnit/lists", params), //产品单位列表
    productUnitDelete: (params) => post("/productUnit/delete", params), //产品单位删除
    productUnitListsDownFile: (params) => downFile("/productUnit/lists", params), //产品单位下载
    productUnitDetail: (params) => post("/productUnit/detail", params), //产品单位列表详情
    productUnitUpdate: (params) => post("/productUnit/update", params), //产品单位列表修改
    productUnitInsert: (params) => post("/productUnit/insert", params), //产品单位列表新增


    //产品相关
    productLists: (params) => post("/product/lists", params), //产品列表
    productDelete: (params) => post("/product/delete", params), //产品删除
    productListsDownFile: (params) => downFile("/product/lists", params), //产品列表下载
    productDetail: (params) => post("/product/detail", params), //单条产品详情
    productInsert: (params) => post("/product/insert", params), //新增产品
    productUpdate: (params) => post("/product/update", params), //修改产品
    flushProductState: (params) => postLong("/product/flushProductState", params), // 刷新产品状态
    flushProductWeight: (params) => postLong("/product/flushProductWeight", params), // 刷新产品状态
    flushProductSchedule: (params) => postLong("/product/flushProductSchedule", params), // 刷新产品计划

    // 产品期间
    productPeriodLists: (params) => post("/productPeriod/lists", params),
    productPeriodDelete: (params) => post("/productPeriod/delete", params),
    productPeriodListsDownFile: (params) => downFile("/productPeriod/lists", params),
    productPeriodDetail: (params) => post("/productPeriod/detail", params),
    productPeriodInsert: (params) => post("/productPeriod/insert", params),
    productPeriodUpdate: (params) => post("/productPeriod/update", params),
    // 产品批文期间
    productLicencePeriodLists: (params) => post("/productLicencePeriod/lists", params),
    productLicencePeriodDelete: (params) => post("/productLicencePeriod/delete", params),
    productLicencePeriodListsDownFile: (params) => downFile("/productLicencePeriod/lists", params),
    productLicencePeriodDetail: (params) => post("/productLicencePeriod/detail", params),
    productLicencePeriodInsert: (params) => post("/productLicencePeriod/insert", params),
    productLicencePeriodUpdate: (params) => post("/productLicencePeriod/update", params),
    // 产品源
    productSourceLists: (params) => post("/productSource/lists", params), //产品别名列表 
    productSourceListsDownFile: (params) => downFile("/productSource/lists", params), //产品别名列表下载
    productSourceInsert: (params) => post("/productSource/insert", params), //新增产品别名
    productSourceUpdate: (params) => post("productSource/update", params), //修改产品别名
    productSourceDelete: (params) => post("/productSource/delete", params), //删除产品别名
    productSourceBatchSave: (params) => postLong("/productSource/batchSave", params), //产品别名批量保存（流向关联产品调用）

    //合作方相关
    partnerLists: (params) => post("/partner/lists", params), //合作方列表
    partnerDelete: (params) => post("/partner/delete", params), //合作方删除
    partnerListsDownFile: (params) => downFile("/partner/lists", params), //合作方列表下载
    partnerDetail: (params) => post("/partner/detail", params), //合作方详情
    partnerInsert: (params) => post("/partner/insert", params), //合作方新增
    partnerUpdate: (params) => post("/partner/update", params), //合作方修改
    flushSchemeDate: (params) => postLong("/partner/flushSchemeDate", params), //刷新规划日
    flushBusinessUnitFromSf: (params) => postLong("/partner/flushBusinessUnitFromSf", params), //刷新业务单元

    // 合作往来相关
    partnerCurrentLists: (params) => post("/partnerCurrent/lists", params),
    partnerCurrentListsDownFile: (params) => downFile("/partnerCurrent/lists", params),
    partnerCurrentDetail: (params) => post("/partnerCurrent/detail", params),
    partnerCurrentInsert: (params) => post("/partnerCurrent/insert", params),
    partnerCurrentUpdate: (params) => post("/partnerCurrent/update", params),
    partnerCurrentDelete: (params) => post("/partnerCurrent/delete", params),

    // 合作往来行相关
    partnerCurrentLineLists: (params) => post("/partnerCurrentLine/lists", params),
    partnerCurrentLineListsDownFile: (params) => downFile("/partnerCurrentLine/lists", params),
    partnerCurrentLineDetail: (params) => post("/partnerCurrentLine/detail", params),
    partnerCurrentLineInsert: (params) => post("/partnerCurrentLine/insert", params),
    partnerCurrentLineUpdate: (params) => post("/partnerCurrentLine/update", params),
    partnerCurrentLineDelete: (params) => post("/partnerCurrentLine/delete", params),


    // 合作往来保留相关
    partnerCurrentWithholdLists: (params) => post("/partnerCurrentWithhold/lists", params),
    partnerCurrentWithholdListsDownFile: (params) => downFile("/partnerCurrentWithhold/lists", params),
    partnerCurrentWithholdInsert: (params) => post("/partnerCurrentWithhold/insert", params),
    // partnerCurrentWithholdDetail: (params) => post("/partnerCurrentWithhold/detail", params),
    // partnerCurrentWithholdUpdate: (params) => post("/partnerCurrentWithhold/update", params),
    // partnerCurrentWithholdDelete: (params) => post("/partnerCurrentWithhold/delete", params),

    // 合作往来核销相关
    partnerCurrentDeductionLists: (params) => post("/partnerCurrentDeduction/lists", params),
    partnerCurrentDeductionListsDownFile: (params) => downFile("/partnerCurrentDeduction/lists", params),

    //联系人相关
    contactLists: (params) => post("/contact/lists", params), //联系人列表
    contactDelete: (params) => post("/contact/delete", params), //联系人删除
    contactListsDownFile: (params) => downFile("/contact/lists", params), //联系人列表下载
    contactDetail: (params) => post("/contact/detail", params), //联系人详情
    contactInsert: (params) => post("/contact/insert", params), //联系人新增
    contactUpdate: (params) => post("/contact/update", params), //联系人修改
    entityContactLists: (params) => post("/entityContact/lists", params), //联系人实体关联列表
    entityContactInsert: (params) => post("/entityContact/insert", params), //新增联系人实体关联
    entityContactUpdate: (params) => post("/entityContact/update", params), //修改联系人实体关联
    entityContactDelete: (params) => post("/entityContact/delete", params), //删除联系人实体关联

    //参数相关
    parametertLists: (params) => post("/parameter/lists", params), //参数列表
    parametertDelete: (params) => post("/parameter/delete", params), //参数删除
    parameterListsDownFile: (params) => downFile("/parameter/lists", params), //参数列表下载
    parameterDetail: (params) => post("/parameter/detail", params), //参数详情
    parameterInsert: (params) => post("/parameter/insert", params), //参数新增
    parameterUpdate: (params) => post("/parameter/update", params), //参数修改

    // 视图管理
    viewManagerLists: (params) => post("/viewManager/lists", params),
    viewManagerFlush: (params) => postLong("/viewManager/flush", params),

    // 物料相关
    materialLists: (params) => post("/material/lists", params),
    materialListsDownFile: (params) => downFile("/material/lists", params),
    materialDetail: (params) => post("/material/detail", params),
    materialInsert: (params) => post("/material/insert", params),
    materialUpdate: (params) => post("/material/update", params),
    materialDelete: (params) => post("/material/delete", params),

    // 物料源相关
    materialSourceLists: (params) => post("/materialSource/lists", params),
    materialSourceListsDownFile: (params) => downFile("/materialSource/lists", params),
    materialSourceDetail: (params) => post("/materialSource/detail", params),
    materialSourceInsert: (params) => post("/materialSource/insert", params),
    materialSourceUpdate: (params) => post("/materialSource/update", params),
    materialSourceDelete: (params) => post("/materialSource/delete", params),

    // 物料类型相关
    materialTypeLists: (params) => post("/materialType/lists", params),
    materialTypeListsDownFile: (params) => downFile("/materialType/lists", params),
    materialTypeDetail: (params) => post("/materialType/detail", params),
    materialTypeInsert: (params) => post("/materialType/insert", params),
    materialTypeUpdate: (params) => post("/materialType/update", params),
    materialTypeDelete: (params) => post("/materialType/delete", params),


    //价格控制相关
    priceControlLists: (params) => post("/priceControl/lists", params), //价格控制列表
    priceControlDelete: (params) => post("/priceControl/delete", params), //价格控制删除
    priceControlListsDownFile: (params) => downFile("/priceControl/lists", params), //价格控制列表下载
    priceControlDetail: (params) => post("/priceControl/detail", params), //价格控制详情
    priceControlBatchAudit: (params) => postLong("/priceControl/batchAudit", params), //价格控制批量审批
    priceControlInsert: (params) => post("/priceControl/insert", params), //价格控制新增
    priceControlUpdate: (params) => post("/priceControl/update", params), //价格控制修改
    priceControlHierarchyInsert: (params) => post("/priceControlHierarchy/insert", params), //单位底价新增
    priceControlHierarchyDelete: (params) => post("/priceControlHierarchy/delete", params), //单位底价删除
    priceControlHierarchyUpdate: (params) => post("/priceControlHierarchy/update", params), //单位底价修改

    //合作规划相关
    partnerSchemeLists: (params) => post("/partnerScheme/lists", params), //合作规划列表
    partnerSchemeDelete: (params) => post("/partnerScheme/delete", params), //合作规划删除
    partnerSchemeListsDownFile: (params) => downFile("/partnerScheme/lists", params), //合作规划列表下载
    partnerSchemeBatchAudit: (params) => postLong("/partnerScheme/batchAudit", params), //合作规划列表批量审批
    partnerSchemeDetail: (params) => post("/partnerScheme/detail", params), //合作规划详情
    partnerSchemeUpdate: (params) => post("/partnerScheme/update", params), //合作规划修改
    partnerSchemeInsert: (params) => post("/partnerScheme/insert", params), //合作规划新增

    //合作价格相关
    partnerPriceLists: (params) => post("/partnerPrice/lists", params), //合作价格列表
    partnerPriceDelete: (params) => post("/partnerPrice/delete", params), //合作价格删除
    partnerPriceListsDownFile: (params) => downFile("/partnerPrice/lists", params), //合作价格列表下载
    partnerPriceBatchAudit: (params) => postLong("/partnerPrice/batchAudit", params), //合作价格列表批量审批
    partnerPriceDetail: (params) => post("/partnerPrice/detail", params), //合作价格详情
    partnerPriceUpdate: (params) => post("/partnerPrice/update", params), //合作价格修改
    partnerPriceInsert: (params) => post("/partnerPrice/insert", params), //合作价格新增

    //订单相关
    orderLists: (params) => post("/order/lists", params), //订单列表
    orderDelete: (params) => post("/order/delete", params), //订单删除
    syncShipmentInfo: (params) => post("/order/syncDealInfoFromKd", params), //同步发货信息
    orderListsDownFile: (params) => downFile("/order/lists", params), //订单列表下载
    orderDetail: (params) => post("/order/detail", params), //订单列表详情
    bestPrice: (params) => post("/partnerPrice/bestPrice", params), //获取合作方最优价
    orderLineLists: (params) => post("/orderLine/lists", params), //订单行列表
    orderLineListsDownFile: (params) => downFile("/orderLine/lists", params), //订单行列表下载
    orderLineDetail: (params) => post("/orderLine/detail", params), //订单行列表详情
    orderInsert: (params) => post("/order/insert", params), //订单新增
    orderUpdate: (params) => post("/order/update", params), //订单修改
    orderDetailLists: (params) => post("/orderDetail/lists", params), //订单行列表
    orderDetailListsDownFile: (params) => downFile("/orderDetail/lists", params), //订单行列表下载
    orderDetailDetail: (params) => post("/orderDetail/detail", params), //订单行列表详情
    dealLineLists: (params) => post("/dealLine/lists", params), //交易行列表
    syncReceivableWriteOffStatus: (params) => post("/dealLine/syncReceivableWriteOffStatus", params), //同步应收单核销状态
    dealLineListsDownFile: (params) => downFile("/dealLine/lists", params), //交易行下载
    dealLineDetail: (params) => post("/dealLine/detail", params), //交易列表详情
    dealDetailLists: (params) => post("/dealDetail/lists", params), //交易明细列表
    dealDetailListsDownFile: (params) => downFile("/dealDetail/lists", params), //交易明细下载
    dealDetails: (params) => post("/dealDetail/detail", params), //交易明细详情

    //回收站相关
    recycleLists: (params) => post("/recycle/lists", params), //回收站列表
    recycleListsDownFile: (params) => downFile("/recycle/lists", params), //回收站列表下载
    recycleBatchDelete: (params) => postLong("/recycle/batchDelete", params), //清空回收站（多选）批量审批
    recycleRestore: (params) => postLong("/recycle/restore", params), //还原回收站（多选）批量审批
    dropdownRecycles: (params) => post("/dropdown/recycles", params), //删除对象下拉列表接口

    //流程规则相关
    procedureLists: (params) => post("/procedure/lists", params), //流程列表
    procedureDetail: (params) => post("/procedure/detail", params), //流程详情
    procedureRuleLists: (params) => post("/procedureRule/lists", params), //流程规则列表
    procedureRuleInsert: (params) => post("/procedureRule/insert", params), //新增流程规则 
    procedureRuleUpdate: (params) => post("/procedureRule/update", params), //修改流程规则
    procedureRuleDelete: (params) => post("/procedureRule/delete", params), //删除流程规则
    procedureCriteria: (params) => post("/dropdown/procedureCriteria", params), //流程规则条件下拉列表
    procedureRuleCheck: (params) => post("/procedureRule/check", params), //流程规则检查

    //流程行相关
    procedureLineLists: (params) => post("/procedureLine/lists", params), //流程行列表
    procedureLineBatchAudit: (params) => post("/procedureLine/batchAudit", params), //流程行列表 （多选）批量审批

    //部门相关
    departmentLists: (params) => post("/department/lists", params), //部门列表
    departmentListsDownFile: (params) => downFile("/department/lists", params), //部门列表下载
    departmentDetail: (params) => post("/department/detail", params), //部门详情
    dropdownDepartmentRank: (params) => post("/dropdown/departmentRank", params), //部门等级下拉
    dropdownDepartment: (params) => post("/dropdown/department", params), //一级部门/二级部门下拉
    departmentInsert: (params) => post("/department/insert", params), //新增部门
    departmentUpdate: (params) => post("/department/update", params), //修改部门 
    departmentDelete: (params) => post("/department/delete", params), //删除部门

    // 职位相关
    hierarchyLists: (params) => post("/hierarchy/lists", params), //职位列表
    hierarchyListsDownFile: (params) => downFile("/hierarchy/lists", params), //职位列表下载
    hierarchyDetail: (params) => post("/hierarchy/detail", params), //职位详情
    hierarchyInsert: (params) => post("/hierarchy/insert", params), //新增职位
    hierarchyUpdate: (params) => post("/hierarchy/update", params), //修改职位
    hierarchyDelete: (params) => post("/hierarchy/delete", params), //删除职位
    dropdownHierarchyLists: (params) => post("/dropdown/hierarchies", params), //职位下拉

    hierarchyMove: (params) => post("/hierarchy/move", params), //移动职位
    saveHierarchies: (params) => post("/hierarchy/saveHierarchies", params), //设置用户层级

    // 人员相关
    personLists: (params) => post("/person/lists", params), //人员列表
    personListsDownFile: (params) => downFile("/person/lists", params), //人员列表下载
    personDetail: (params) => post("/person/detail", params), //人员详情
    dropdownPerson: (params) => post("/dropdown/persons", params), //人员下拉
    personInsert: (params) => post("/person/insert", params), //新增人员
    personUpdate: (params) => post("/person/update", params), //修改人员 
    personDelete: (params) => post("/person/delete", params), //删除人员

    // 任职记录
    hierarchyPersonLists: (params) => post("/hierarchyPerson/lists", params), //任职记录列表
    hierarchyPersonListsDownFile: (params) => downFile("/hierarchyPerson/lists", params), //任职记录列表下载
    hierarchyPersonDetail: (params) => post("/hierarchyPerson/detail", params), //任职记录详情
    hierarchyPersonInsert: (params) => post("/hierarchyPerson/insert", params), //新增任职记录
    hierarchyPersonUpdate: (params) => post("/hierarchyPerson/update", params), //修改任职记录
    hierarchyPersonDelete: (params) => post("/hierarchyPerson/delete", params), //删除任职记录

    // 合同相关
    personContractLists: (params) => post("/personContract/lists", params), //合同列表
    personContractListsDownFile: (params) => downFile("/personContract/lists", params), //合同列表下载
    personContractInsert: (params) => post("/personContract/insert", params), //合同新增
    personContractUpdate: (params) => post("/personContract/update", params), //修改合同
    personContractDelete: (params) => post("/personContract/delete", params), //合同删除
    personContractDetail: (params) => post("/personContract/detail", params), //合同详情

    personExperienceLists: (params) => post("/personExperience/lists", params), //经历列表
    personExperienceListsDownFile: (params) => downFile("/personExperience/lists", params), //经历列表下载
    personExperienceInsert: (params) => post("/personExperience/insert", params), //经历新增
    personExperienceUpdate: (params) => post("/personExperience/update", params), //修改经历
    personExperienceDelete: (params) => post("/personExperience/delete", params), //经历删除
    personExperienceDetail: (params) => post("/personExperience/detail", params), //经历详情

    //预算相关
    budgetSubjectLists: (params) => post("/budgetSubject/lists", params), //预算科目列表
    budgetSubjectListsDownFile: (params) => downFile("/budgetSubject/lists", params), //预算科目列表下载
    budgetSubjectDelete: (params) => post("/budgetSubject/delete", params), //预算科目删除
    dropdownBudgetSubjects: (params) => post("/dropdown/budgetSubjects", params), //预算科目下拉
    budgetSubjectDetail: (params) => post("/budgetSubject/detail", params), //预算科目列表详情
    budgetSubjectTnsert: (params) => post("/budgetSubject/insert", params), //预算科目新增
    budgetSubjectUpdate: (params) => post("/budgetSubject/update", params), //预算科目编辑
    //预算项目
    searchBudgetSubject: (params) => post("/search/budgetSubjects", params), //预算科目搜索下拉
    searchBudgetItems: (params) => post("/search/budgetItems", params), //预算项目搜索下拉
    dropdownProjects: (params) => post("/dropdown/projects", params), //项目下拉
    budgetItemInsert: (params) => post("/budgetItem/insert", params), //新增预算项目
    budgetItemUpdate: (params) => post("/budgetItem/update", params), //修改预算项目
    budgetItemClose: (params) => post("/budgetItem/close", params), //关闭预算项目
    budgetExecutionLists: (params) => post("/budgetExecution/lists", params), //预算项目详情下预算执行行列表
    budgetExecutionDownFile: (params) => downFile("/budgetExecution/lists", params), //预算项目详情下预算执行行列表下载
    budgetItemReOpen: (params) => post("/budgetItem/reOpen", params), //重新打开预算项目
    budgetItemLists: (params) => post("/budgetItem/lists", params), //预算项目列表
    budgetItemFreezingLists: (params) => post("/budgetItem/freezingLists", params), //冻结中列表
    budgetItemListsDownFile: (params) => downFile("/budgetItem/lists", params), //预算项目列表下载
    budgetItemDetail: (params) => post("/budgetItem/detail", params), //预算项目明细
    budgetItemDelete: (params) => post("/budgetItem/delete", params), //删除预算项目
    budgetItemChangeBudget: (params) => post("/budgetItem/changeBudget", params), //预算调整 
    dropdownControlScope: (params) => post("/dropdown/controlScope", params), //控制范围下拉
    //预算对象
    budgetObjectLists: (params) => post("/budgetObject/lists", params), //预算对象列表
    budgetObjectListsDownFile: (params) => downFile("/budgetObject/lists", params), //预算对象列表下载
    budgetObjectInsert: (params) => post("/budgetObject/insert", params), //新增预算对象
    budgetObjectUpdate: (params) => post("/budgetObject/update", params), //修改预算对象
    budgetObjectDetail: (params) => post("/budgetObject/detail", params), //预算对象详情
    budgetObjectDelete: (params) => post("/budgetObject/delete", params), //删除预算对象
    dropdownBudgetObject: (params) => post("/dropdown/budgetObject", params), //预算对象下拉（选上级）
    budgetObjectSyncToSubject: (params) => post("/budgetObject/syncToSubject", params), //同步到预算科目
    //预算执行
    budgetExecutionReportLists: (params) => post("/budgetExecutionReport/lists", params), //预算执行列表
    dropdownFeeTypes: (params) => post("/dropdown/feeTypes", params), //费用类型下拉接口
    refreshPayment: (params) => postLong("/budgetExecutionReport/refreshPayment", params), //预算执行列表刷新支付信息
    dropdownCorpType: (params) => post("/dropdown/corpType", params), //对公业务类型下拉
    budgetExecutionReportHistories: (params) => post("/budgetExecutionReport/histories", params), //历史业务下拉接口
    toBeWrittenOffLists: (params) => post("/budgetExecutionReport/toBeWrittenOffLists", params), //冲销行下拉接口
    budgetExecutionReportListsDownFile: (params) => downFile("/budgetExecutionReport/lists", params), //预算执行列表下载
    budgetExecutionReportDetail: (params) => post("/budgetExecutionReport/detail", params), //预算执行详情
    budgetExecutionReportInsert: (params) => post("/budgetExecutionReport/insert", params), //新增预算执行报告
    budgetExecutionReportUpdate: (params) => post("/budgetExecutionReport/update", params), //修改预算执行报告
    budgetExecutionReportDelete: (params) => post("/budgetExecutionReport/delete", params), //删除预算执行报告
    budgetExecutionReportSubmit: (params) => post("/budgetExecutionReport/submit", params),
    budgetExecutionReportInsertDetail: (params) => post("/budgetExecutionReport/insertDetail", params), //新增预算执行（详情里面新增一行）
    budgetExecutionReportDeleteDetail: (params) => post("/budgetExecutionReport/deleteDetail", params), //删除预算执行（详情里面删除一行）
    budgetExecutionReportUpdateDetail: (params) => post("/budgetExecutionReport/updateDetail", params), //修改预算执行行
    //预算源组
    dropdownGroupDirection: (params) => post("/dropdown/groupDirection", params), //预算源组方向下拉
    dropdownGroupScope: (params) => post("/dropdown/groupScope", params), //预算源组范围下拉
    dropdownBudgetItemSourceGroups: (params) => post("/dropdown/budgetItemSourceGroups", params), //预算源组下拉
    budgetItemSourceGroupLists: (params) => post("/budgetItemSourceGroup/lists", params), //预算源组列表
    budgetItemSourceGroupListsDownFile: (params) => downFile("/budgetItemSourceGroup/lists", params), //预算源组列表
    budgetItemSourceLists: (params) => post("/budgetItemSource/lists", params), //按源审批-预算源组列表  预算源列表
    budgetItemSourceListsDownFile: (params) => downFile("/budgetItemSource/lists", params), //按源审批-预算源组列表下载 预算源列表下载
    budgetItemSourceGroupInsert: (params) => post("/budgetItemSourceGroup/insert", params), //新增预算源组
    budgetItemSourceGroupSubmit: (params) => post("/budgetItemSourceGroup/submit", params),
    budgetItemSourceGroupUpdate: (params) => post("/budgetItemSourceGroup/update", params), //修改预算源组
    budgetItemSourceGroupDelete: (params) => post("/budgetItemSourceGroup/delete", params), //删除预算源组
    budgetItemSourceGroupDetail: (params) => post("/budgetItemSourceGroup/detail", params), //预算源组详情
    budgetItemSourceInsert: (params) => post("/budgetItemSource/insert", params), //新增预算源
    budgetItemSourceUpdate: (params) => post("/budgetItemSource/update", params), //修改预算源
    budgetItemSourceDelete: (params) => post("/budgetItemSource/delete", params), //删除预算源
    budgetItemSourceDetail: (params) => post("/budgetItemSource/detail", params), //预算源详情
    budgetItemSourceBatchAudit: (params) => post("/budgetItemSource/batchAudit", params), //预算源审批
    budgetItemSourceGroupBatchAudit: (params) => post("/budgetItemSourceGroup/batchAudit", params), //预算源组审批
    dropdownEffectiveness: (params) => post("/dropdown/effectiveness", params), //有效性下拉接口
    dropdownFlowCredentials: (params) => post("/dropdown/flowCredentials", params), //流向凭据编码下拉
    dropdownAccountParentType: (params) => post("/dropdown/accountParentType", params), //账户父级绑定类型



};
export default api;